import { render, staticRenderFns } from "./FaqAndSupportReviews.vue?vue&type=template&id=90cf00b8&scoped=true"
import script from "./FaqAndSupportReviews.vue?vue&type=script&lang=js"
export * from "./FaqAndSupportReviews.vue?vue&type=script&lang=js"
import style0 from "./FaqAndSupportReviews.vue?vue&type=style&index=0&id=90cf00b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90cf00b8",
  null
  
)

export default component.exports